export default __webpack_public_path__ + "static/6904-50aa0dc8f1a874b6299b57ae81a270d9.jpg";